import React from "react";
import PropTypes from 'prop-types';
import emptyCard from "../../assets/images/project-img/rites-blank-img.svg";

const EmptyCard = ({selectField})=>{
    return(
        <>
            <div className="d-flex justify-content-center">
                <div className="text-center">
                    <img src={emptyCard} alt="" />
                    <div className="text-center mt-4">
                        <p style={{fontSize:"20px", fontWeight:"600"}} className="mb-1">Quality check sheet will appear here</p>
                        {/* <p style={{color:"#00000066", fontSize:"16px", fontWeight:"400"}}>Select first <b>{selectField} </b>from the dropdown to continue.</p> */}
                        {selectField!==""? <p style={{color:"#00000066", fontSize:"16px", fontWeight:"400"}}>Select first <b>{selectField} </b>from the dropdown to continue.</p>:''}
                    </div>
                </div>
            </div>
        </>
    )
}
EmptyCard.propTypes = {
  selectField: PropTypes.string.isRequired,
};
export default EmptyCard;